// import Swiper JS
import Swiper, { Navigation, Pagination, Scrollbar, dragSize } from 'swiper';

// import Swiper styles
import 'swiper/swiper-bundle.css';


function displayAllCounters() {
    const counterElements = document.querySelectorAll('.counter');
    counterElements.forEach(element => {
        let counter = element.getAttribute("data-count");
        element.textContent = counter;
    });
}

function animateCounters() {
    const counterElements = document.querySelectorAll('.counter');
    counterElements.forEach(element => {
        let counter = element.getAttribute("data-count");
        let count = 0;
        const target = parseInt(counter);
        const speed = 50;

        function increment() {
            if (count < target) {
                count++;
                element.textContent = count;
            }
        }

        // Start the counting animation for the element
        const intervalId = setInterval(increment, speed);

        // Stop the animation when the target number is reached
        if (count === target) {
            clearInterval(intervalId);
        }
    });
}

const targetDiv = document.getElementById('testimonial-div');
function isInViewport(element)
{
    const rect = element.getBoundingClientRect();
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight);
}

let hasFunctionExecuted = false;

function onScroll()
{
    if (!hasFunctionExecuted && isInViewport(targetDiv)) {
        // Execute your function here
        console.log("The div is in the viewport. Executing your function.");
        animateCounters();
        hasFunctionExecuted = true; // Ensure the function is executed only once
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const counterElem = document.querySelector('.testimonial-div');

    if (counterElem) {

        if (window.innerWidth > 768) {
            // Attach the scroll event listener
            //window.addEventListener('scroll', handleIntersection);
            window.addEventListener('scroll', onScroll);
        } else {
            //displayAllCounters();
        }

        // Initialize Swiper
        new Swiper('#testimonial-swiper-container', {
            slidesPerView: 1,
            spaceBetween: 5,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    }
});